import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { firstValueFrom, lastValueFrom } from 'rxjs';

import {
	setName,
	setRoles,
	setPrivileges,
	setSessionParams,
	setUsername,
	setUserId,
} from 'shared/auth/store/auth.actions';
import { IAuthStore } from 'shared/auth/store/auth.reducer';
import { AdminApplicationPreloadResponse } from 'shared/openapi/models/admin-application-preload-response';
import { AdminApplicationPreloadService } from 'shared/openapi/services/admin-application-preload.service';
import { LoggerService } from 'shared/services/logger.service';

@Injectable({
	providedIn: 'root',
})
export class ApplicationPreloadService {
	constructor(
		private logger: LoggerService,
		private store: Store<{ auth: IAuthStore }>,
		private adminApplicationPreloadService: AdminApplicationPreloadService
	) {}

	async preload() {
		await lastValueFrom(this.adminApplicationPreloadService.preloadAdmin())
			.then((response: AdminApplicationPreloadResponse) => {
				this.store.dispatch(
					setName({
						payload: {
							name: response.name,
						},
					})
				);
				this.store.dispatch(setRoles({ payload: response }));
				this.store.dispatch(setPrivileges({ payload: response }));
				this.store.dispatch(setUsername({ payload: { username: response.username } }));
				this.store.dispatch(setUserId({ payload: { userId: response.userId } }));
				this.store.dispatch(
					setSessionParams({
						payload: {
							sessionPeriod: response.sessionParams?.sessionPeriodInSec,
						},
					})
				);
			})
			.catch((error) => {
				this.logger.log(this.constructor.name, this.preload.name, error);
			});
	}

	public getAuthState(): Promise<IAuthStore> {
		return firstValueFrom(this.store.pipe(select('auth')));
	}
}
